<!-- Dynamic Cards View - Renders fields based on API headers (fielddisplayon=4) -->
<!-- Follows same patterns as base-grid for permissions, field types, and conditional actions -->
<div class="base-cards-container">
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <span class="loading-text">{{ 'loading' | translate }}...</span>
    </div>
  } @else if (cardData.length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-icon">inbox</mat-icon>
      <p class="empty-text">{{ 'noDataFound' | translate }}</p>
    </div>
  } @else {
    <div class="cards-grid">
      @for (item of cardData; track item.id || $index) {
        <div class="card-item" (click)="onCardClick(item)">
          <div class="card-header">
            <!-- Card Avatar - dynamically detected from API headers, same as base-grid image handling -->
            @if (hasCardImage()) {
              <div class="card-avatar">
                <img [src]="getCardAvatarUrl(item)" alt="avatar" class="avatar-image" />
              </div>
            }
            <span class="card-title">{{ getCardTitle(item) }}</span>
            <div class="card-actions">
              <!-- Edit button - same permission checks as base-grid -->
              @if (canEdit && permissions?.edit && enabledByFieldValue(item)) {
                <button type="button"
                  class="action-btn edit-btn text-muted"
                  (click)="onEditClick($event, item)"
                  [matTooltip]="'edit' | translate">
                  <i class="ti ti-edit-circle f-18" aria-hidden="true"></i>
                </button>
              } @else if (enabledByFieldValue(item)) {
                <!-- View button when no edit permission - same as base-grid -->
                <button type="button"
                  class="action-btn view-btn text-muted"
                  (click)="onEditClick($event, item)"
                  [matTooltip]="'view' | translate">
                  <i class="ti ti-eye f-18" aria-hidden="true"></i>
                </button>
              }
              <!-- Delete button - same permission checks as base-grid -->
              @if (canDelete && permissions?.delete && enabledByFieldValue(item) && deleteEnabledByFieldValue(item)) {
                <button type="button"
                  class="action-btn delete-btn text-warn-500"
                  (click)="onDeleteClick($event, item)"
                  [matTooltip]="'delete' | translate">
                  <i class="ti ti-trash f-18" aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>

          <div class="card-body">
            @for (header of cardHeaders; track header.fieldname) {
              <!-- Skip: name fields (shown in title), image fields (shown in avatar), and id -->
              @if (!header.fieldname.endsWith('araname') && !header.fieldname.endsWith('latname') && header.fieldname !== 'name' && header.fieldname !== 'id' && !isImageField(header)) {
                <div class="card-field">
                  <!-- Phone fields - same as base-grid with phoneFormat pipe -->
                  @if (isPhoneField(header)) {
                    <span class="field-value field-phone" dir="ltr">
                      {{ item[header.fieldname] ? (item[header.fieldname] | phoneFormat) : '----' }}
                    </span>
                  } @else if (header.fieldtype === 'boolean' || header.fieldtype === 'bit') {
                    <!-- Boolean/bit fields -->
                    <span class="field-value field-boolean">
                      <mat-icon class="boolean-icon" [class.true]="item[header.fieldname]">
                        {{ item[header.fieldname] ? 'check_circle' : 'cancel' }}
                      </mat-icon>
                    </span>
                  } @else {
                    <!-- Normal fields -->
                    <span class="field-value">{{ getFieldValue(item, header) }}</span>
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </div>

    <!-- Paginator - exactly like base-grid -->
    <div class="cards-footer">
      <mat-paginator #paginator
        [length]="totalCount"
        [pageSizeOptions]="pageSizes"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  }
</div>
